import React, { useEffect, useRef, useState } from 'react';
type GetTermsEmbedProps = {
  documentName: 'privacy' | 'terms-of-service';
};
type EmbedStatus = 'loading' | 'ready' | 'error';
const GETTERMS_EMBED_SCRIPT_ID = 'getterms-embed-js';
const GETTERMS_EMBED_SCRIPT_URL = 'https://gettermscdn.com/dist/js/embed.js';
export function GetTermsEmbed({
  documentName
}: GetTermsEmbedProps) {
  const containerRef = useRef<HTMLDivElement>(null);
  const [status, setStatus] = useState<EmbedStatus>('loading');
  useEffect(() => {
    let cancelled = false;
    let frameId: number | undefined;
    setStatus('loading');
    const mountEmbed = () => {
      if (cancelled || !containerRef.current) return;

      // The GetTerms library scans the DOM only when its script executes.
      // Replacing the script on route changes lets it detect this newly mounted target.
      document.getElementById(GETTERMS_EMBED_SCRIPT_ID)?.remove();
      containerRef.current.replaceChildren();
      const script = document.createElement('script');
      script.id = GETTERMS_EMBED_SCRIPT_ID;
      script.type = 'text/javascript';
      script.src = GETTERMS_EMBED_SCRIPT_URL;
      script.async = true;
      script.onload = () => {
        if (!cancelled) setStatus('ready');
      };
      script.onerror = () => {
        if (!cancelled) setStatus('error');
      };
      document.head.appendChild(script);
    };

    // Wait until React has committed the current route's embed element to the DOM.
    frameId = window.requestAnimationFrame(mountEmbed);
    return () => {
      cancelled = true;
      if (frameId !== undefined) window.cancelAnimationFrame(frameId);
    };
  }, [documentName]);
  return <div data-id="element-14" data-mp="220ivah53z001">
      {status === 'loading' && <p className="mb-6 text-sm text-text-muted" role="status" data-id="element-15" data-mp="270wrn1xckli8">
          文書を読み込んでいます…
        </p>}
      {status === 'error' && <p className="mb-6 text-sm text-text-muted" role="alert" data-id="element-16" data-mp="2upy7394lkwx0">
          文書を読み込めませんでした。時間をおいて再度お試しください。
        </p>}
      <div ref={containerRef} className="getterms-document-embed leading-[1.7] [&_a]:text-sky-blue [&_a]:underline hover:[&_a]:text-deep-navy [&_h2]:mb-4 [&_h2]:mt-12 [&_h2]:text-2xl [&_h2]:font-bold [&_h3]:mb-4 [&_h3]:mt-8 [&_h3]:text-xl [&_h3]:font-bold [&_h4]:mb-3 [&_h4]:mt-6 [&_h4]:text-lg [&_h4]:font-bold [&_li]:mb-2 [&_ol]:mb-6 [&_ol]:list-decimal [&_ol]:pl-6 [&_p]:mb-6 [&_ul]:mb-6 [&_ul]:list-disc [&_ul]:pl-6" data-getterms="Ki4O5" data-getterms-document={documentName} data-getterms-lang="en-us" data-getterms-mode="direct" data-getterms-env="https://gettermscdn.com" data-id="element-17" data-mp="39dzjywi0d1k9" />
    </div>;
}